module.exports = __webpack_public_path__ + "img/play.8ee68614.png";